import { Typography, SxProps, Theme } from "@mui/material";

interface SectionSubtitleProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const SectionSubtitle = ({ children, sx }: SectionSubtitleProps) => {
  return (
    <Typography
      variant="body1"
      sx={{
        textAlign: "center",
        fontSize: { md: "1.1rem", xs: "0.95rem" },
        color: "#666",
        marginTop: "-8px",
        marginBottom: "20px",
        marginLeft: "auto",
        marginRight: "auto",
        lineHeight: 1.8,
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
};
